import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Error Budget',
  slug: 'error-budget',
  definition: `An error budget is the maximum amount of downtime or errors your service can have before violating its SLA. It is calculated as 100% minus your SLA target. If your SLA promises 99.9% uptime, your error budget is 0.1% of the total time period.

For a monthly SLA of 99.9%, the error budget is about 43 minutes. That means your service can be down for a total of 43 minutes in a month without breaching the agreement. Once you have used up the budget, any additional downtime is an SLA violation.

Error budgets come from Google's Site Reliability Engineering (SRE) practices. They reframe reliability as a resource to be spent rather than a constraint to be feared. When you have error budget remaining, you can take risks like deploying new features. When the budget is low, you focus on stability.`,
  whyItMatters: `Error budgets create a shared framework for product and engineering teams to make tradeoff decisions. Instead of arguing about whether to ship a risky feature or focus on reliability, the error budget gives an objective answer.

When the budget is healthy, the team can move fast and accept some risk. When the budget is nearly exhausted, the team slows down and prioritizes stability. This prevents both extremes: reckless shipping and excessive caution.`,
  howUptrackHelps: `Uptrack provides precise downtime measurements that feed directly into error budget calculations. With 30-second check intervals, you get an accurate accounting of every minute of downtime, so your error budget is based on real data, not estimates.

You can track your uptime percentage over any time window and immediately see how much error budget you have remaining for the current period.`,
  formula: 'Error Budget = 100% - SLA Target (e.g., 100% - 99.9% = 0.1% = 43 min/month)',
  relatedTerms: [
    { name: 'SLA', href: '/glossary/sla' },
    { name: 'Five Nines', href: '/glossary/five-nines' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'Downtime', href: '/glossary/downtime' },
  ],
}

export const Route = createFileRoute('/_site/glossary/error-budget')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
